import { render, staticRenderFns } from "./RtcGroupVideo.vue?vue&type=template&id=c244d0b4&scoped=true"
import script from "./RtcGroupVideo.vue?vue&type=script&lang=js"
export * from "./RtcGroupVideo.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupVideo.vue?vue&type=style&index=0&id=c244d0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c244d0b4",
  null
  
)

export default component.exports